export default __webpack_public_path__ + "static/media/detail_small_9_5.3fee2c1a.jpg";